export default ({ request }) => ({
  ecomEvgSkuListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuDelApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuFullMemberApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/fullMember',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuCopyApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/copy',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuInformationApplyApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/information/apply',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuInformationApprovedApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/information/approved',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuInformationRejectApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/information/reject',
      method: 'POST',
      data,
    })
  },
  //  产品图片
  ecomEvgSkuImageListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/image/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuImageUploadApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/image/upload',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuImageSetDefaultApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/image/setDefault',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuImageDelApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/image/del',
      method: 'POST',
      data,
    })
  },

  //生产厂家
  ecomEvgSkuFtyListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/fty/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuFtyDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/fty/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuFtySaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/fty/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuFtyDelApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/fty/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuFtyMatchNoResultReturnDefaultApi(params = {}) {
    return request({
      url: '/ecom/evg/sku/fty/matchNoResultReturnDefault',
      method: 'GET',
      params,
    })
  },
  ecomEvgSkuListBySpuCodeApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/listBySpuCode',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuDetailPrintViewApi(params = {}) {
    return request({
      url: '/ecom/evg/sku/print/detail',
      method: 'GET',
      params,
    })
  },
  ecomEvgSkuFtyScmNcNoApi(params = {}) {
    return request({
      url: '/ecom/evg/sku/fty/scm/ncNo',
      method: 'GET',
      params,
    })
  },

  ecomEvgSkuFtyPrintScmListApi(params = {}) {
    return request({
      url: '/ecom/evg/sku/fty/print/scm/list',
      method: 'GET',
      params,
    })
  },
  ecomEvgSkuPlatformListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/platform/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecPageListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/pageList',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecSetNctApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/setNc',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecDelApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricChooseFabricListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/choose/fabric/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricSaveBatchApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/save/batch',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricEditSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/edit/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecFabricDelApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/fabric/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialListApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuMaterial/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecMaterialListApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuSpecMaterial/list',
      method: 'POST',
      data,
    })
  },

  ecomEvgSkuMaterialImageListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/material/image/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialDetailApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuMaterial/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialImageSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/material/image/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialSaveApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuMaterial/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialDelApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuMaterial/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialMaterialApi(data = {}) {
    return request({
      url: '/ecom/ecomEvgSkuMaterial/material',
      method: 'POST',
      data,
    })
  },

  ecomEvgSkuMaterialImageDelApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/material/image/del',
      method: 'POST',
      data,
    })
  },

  ecomEvgSkuMaterialImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/material/image/updateSortOrder',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuPurchasableApplyApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/purchasable/apply',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuPlaceListApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/place/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuNcDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/ncDetail',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuNcSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/ncSave',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuReturnApplicationApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/returnApplication',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuSpecEditImageApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/spec/editImage',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuUpdateSizeApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/update/size',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuCustomsApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/customs',
      method: 'POST',
      data,
    })
  },
  ecomEvgSkuMaterialInfoApi(data = {}) {
    return request({
      url: '/ecom/evg/sku/material/info',
      method: 'POST',
      data,
    })
  },
})
